// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Icon", "class-variance-authority"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Icon"), require("class-variance-authority"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Icon, global.classVarianceAuthority);
    global.Icon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Icon, _classVarianceAuthority) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IconButton = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var iconButton = (0, _classVarianceAuthority.cva)(['cop-rounded', 'hover:cop-opacity-80', 'cop-transition-opacity', 'cop-flex', 'cop-items-center', 'cop-shadow-none', 'cop-cursor-pointer', 'cop-border', 'cop-border-solid', 'cop-border-[#00000012]', 'peer-focus-visible:cop-outline-2', ' peer-focus-visible:cop-outline-[#053299]', 'cop-outline-offset-[3px]'], {
    variants: {
      variant: {
        primary: ['cop-bg-[#212B36]', 'cop-text-white', 'cop-border', 'hover:cop-bg-[#161D26]', 'disabled:cop-bg-secondary'],
        secondary: ['cop-bg-transparent', 'cop-text-current', 'hover:cop-bg-[#F8F9FB]'],
        minimal: ['cop-border-transparent', 'cop-bg-transparent', 'cop-text-current', 'hover:cop-bg-[#F8F9FB]']
      },
      size: {
        sm: ['cop-p-[5px]'],
        base: ['cop-p-[7px]']
      },
      disabled: {
        "true": ['cop-pointer-events-none', 'cop-cursor-default', '!cop-text-gray-300'],
        "false": ['cop-cursor-pointer']
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'base'
    }
  });
  var IconButton = _exports.IconButton = function IconButton(_ref) {
    var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      size = _ref.size,
      variant = _ref.variant,
      disabled = _ref.disabled;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: iconButton({
        variant: variant,
        size: size,
        className: className,
        disabled: disabled
      }),
      onClick: onClick,
      "aria-label": label,
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: icon,
      className: "cop-h-4 cop-w-4"
    }));
  };
});
